var logger = require('loglevel');

var methods = ['trace', 'debug', 'info', 'warn', 'error'];

function d() {
    return new Date();
}

function log(level, prefix) {
    var c = "|" + level.toUpperCase() + "|" + prefix + "|";
    
    return function(msg, arg) {
        if (arg) {
            logger[level](d() + c + msg, arg); 
        } else {
            logger[level](d() + c + msg);
        }
    };
}

function create(classname) {    
    var l = {};
    
    methods.forEach(function(m) {
        l[m] = log(m, classname);
    });
        
    return l;
}

module.exports = {
    create : create,
    setLevel : logger.setLevel
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/util/logger.js
// module id = 35
// module chunks = 1